import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = { slot: "bottom-sheet-content" }
const _hoisted_4 = { slot: "bottom-sheet-content" }
const _hoisted_5 = { slot: "bottom-sheet-content" }
const _hoisted_6 = { class: "profile-creation-wizard__side-description" }
const _hoisted_7 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_8 = { class: "profile-creation-wizard__side-description" }
const _hoisted_9 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "profile-creation-wizard__side-description" }
const _hoisted_12 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_13 = { class: "profile-creation-wizard__side-description" }
const _hoisted_14 = { class: "profile-creation-wizard__side-iconTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-location-bottom-sheet",
        "data-testid": "details-location-bottom-sheet-tips",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.help')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.location.subtitle')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.location.workplace.subtitle')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"]),
      _createVNode(_component_joy_bottom_sheet, {
        id: "completion-languages-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.help')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.languages.subtitle')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"]),
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-phone-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.phone.help')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.phone.subtitle')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !_ctx.isLocationFocus, 'focus-location': _ctx.isLocationFocus}]),
        "data-testid": "details-location-desktop-tips",
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_joy_icon, {
              name: "location",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.location.title')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.location.subtitle')), 1),
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.location.workplace.subtitle')), 1)
        ])
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !_ctx.isLanguagesFocus, 'focus-language': _ctx.isLanguagesFocus}]),
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_joy_icon, {
              name: "megaphone",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.languages.title')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.languages.subtitle')), 1)
        ])
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !_ctx.isPhoneFocus, 'focus-phone': _ctx.isPhoneFocus}]),
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_joy_icon, {
              name: "phone",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.phone.title')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.phone.subtitle')), 1)
        ])
      ], 6)
    ])
  ]))
}